module.exports = __webpack_public_path__ + "img/graph.1cf6c320.svg";